import asyncRequestHandler from 'helpers/functions/AsyncRequestHandler';
import { ThunkResult } from 'redux/types';
import { listIPWhitelist, removeIPWhitelist, upsertIPWhitelist } from 'services/API/IPWhitelist';
import {
  IPWhitelistMutationRequest,
  IPWhitelistPaginatedResponse,
} from 'services/API/IPWhitelist/interface';
import { AnyResponse } from 'services/API/common/Fetcher';

export const getIPWhitelistAction = (
  companyId: string,
  params?: Record<string, any>,
): ThunkResult<Promise<IPWhitelistPaginatedResponse>> =>
  asyncRequestHandler(() => listIPWhitelist(companyId, params));

export const upsertIPWhitelistAction = (
  companyId: string,
  payload: IPWhitelistMutationRequest,
): ThunkResult<Promise<AnyResponse>> =>
  asyncRequestHandler(() => upsertIPWhitelist(companyId, payload));

export const deleteIPWhitelistAction = (
  companyId: string,
  whitelistId: string,
): ThunkResult<Promise<AnyResponse>> =>
  asyncRequestHandler(() => removeIPWhitelist(companyId, whitelistId));
